// extracted by mini-css-extract-plugin
export default {"faq":"FEhptQrEj_UoZfyAMAqw","menu":"ak9kc3XhmVjGEgBYquQO","menuInner":"h8j7fOGIsiZcYrz6XDA1","questionGroups":"CGMxB2nrrxl6HdwceKFY","questionGroup":"Kks8bBkd_Avgq6eL4WyF"};